<template>
  <div class="password-recover">
    <div class="title">Восстановление пароля</div>
    <div class="divider"></div>
    <form
      class="password-recover__form container pa-0 grid-list-lg"
      @submit.prevent="submit"
      @keyup.enter="submit"
    >
      <div class="form-row layout row wrap">
        <div class="flex xs12 offset-sm1 sm10 d-flex align-center">
          <div class="form-label">E-mail:</div>
        </div>
        <div class="flex xs12 offset-sm1 sm10 form-fields">
          <input
            type="email"
            class="form-input"
            :class="{ invalid: isInvalid('email') }"
            placeholder="Введите E-mail"
            v-model="$v.form.email.$model"
          />
        </div>
      </div>

      <div class="form-row layout row wrap">
        <div class="flex xs12 offset-sm1 sm10">
          <p class="password-recover__message">{{ message }}</p>
        </div>
        <div class="flex xs12 offset-sm2 sm8">
          <AppBtn
            :loading="loading"
            round
            block
            color="orange-grad"
            class="px-6"
            type="submit"
            @click="submit"
          >
            <span>Отправить</span>
          </AppBtn>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { getValidationMessage } from "@utils/validation-messages";
import { required, email } from "vuelidate/lib/validators";
import { requestAlert, showAlert } from "@/services/common/showAlert";
import { asyncModal } from "@/components/ui/modal/";
import service from "@/services/contest/auth";

const defaultForm = () => ({
  email: ""
});

const PasswordRecover = {
  name: "PasswordRecover",

  data: () => ({
    form: defaultForm(),
    loading: false,
    message: ""
  }),

  validations: {
    form: {
      email: { required, email }
    }
  },

  methods: {
    getError(field) {
      return getValidationMessage(this.$v.form[field]);
    },

    isInvalid(field) {
      return this.$v.form[field].$error;
    },

    async submit() {
      if (this.loading) return;
      this.$v.$touch();
      this.message = "";
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const { success, message } = await service.resetPasswordRequest(
          this.form.email
        );
        if (success) {
          await showAlert(message);
          this.$modals.close(this);
        } else {
          this.message = message;
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};

export default PasswordRecover;

export function openModal() {
  return asyncModal({
    name: "password-recover-modal",
    component: PasswordRecover
  });
}
</script>

<style lang="scss">
.password-recover {
  &-modal {
    .modal-card {
      width: 100%;
      max-width: 470px;

      .title {
        font-size: 26px;
        line-height: 1.5;

        @include breakpoint("xs-only") {
          font-size: 16px;
        }
      }
    }
  }

  .form-fields {
    @include breakpoint("xs-only") {
      padding-top: 0 !important;
    }
  }

  &__message {
    text-align: center;
    margin-bottom: 10px;
    min-height: 30px;
  }
}
</style>
